<template>
  <app-layout>
    <template v-slot:submenu>
      <sub-menu>
        <router-link :to="{ name: 'ListMeters', query: { site_id: this.site_uuid, location_id: location_uuid } }" class="btn btn-outline-dark">
          <show-icon name="back" size="sm" class="align-middle"></show-icon>
          <span class="d-none d-sm-inline">{{ $t("back") }}</span>
        </router-link>
      </sub-menu>
    </template>

    <template v-slot:default>
      <MeterForm 
        meter-uuid=""
        :meter-type="meter_type"
        :site-uuid="site_uuid"
        :location-uuid="location_uuid"
        @meter-created="onMeterCreated"
      ></MeterForm>
    </template>
  </app-layout>
</template>
<script>
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import MeterForm from './Form.vue';

export default {
  name: "MeterNew",
  setup() {
    const store = useStore();
    const route = useRoute();
    const site_uuid = route.query.site_id;

    const meter_type = route.query.type;

    const location_uuid = route.query.location_id;
    const location = (location_uuid) ? store.getters.getLocationByUUID(location_uuid) : null;

    const asset_uuid = route.query.asset_id;
    const asset = (asset_uuid) ? store.getters.getAssetByUUID(asset_uuid) : null;
    
    return {
      meter_type,
      site_uuid,
      location,
      location_uuid,
      asset
    }    
  },
  methods: {
    onMeterCreated(e) {
      console.log("meters/New.vue, onMeterCreated, e.meter_uuid ==> ", e.meter_uuid);
      this.$router.push({ name: "ShowMeter", params: { id: e.meter_uuid} });
    }
  },
  components: {
    MeterForm
  }
}
</script>